import { useWorkspaceContext } from "../state/workspaceContext";
import { useCanManageWorkspace } from "./permissions/useCanManageWorkspace";
import { useCanManageWorkspaceMembers } from "./permissions/useCanManageWorkspaceMembers";

export function useShowWorkspaceSettings() {
    const canManageWorkspace = useCanManageWorkspace();
    const canManageWorkspaceMembers = useCanManageWorkspaceMembers();
    const { activeWorkspace } = useWorkspaceContext();

    if (!activeWorkspace) {
        return false;
    }

    return canManageWorkspaceMembers || canManageWorkspace;
}
